
import { ActionTree } from 'vuex';
import { ContactPanelState } from './types';
import { RootState } from '../../types';
import { defaultBackendContactPanel } from '@/shared/backend/contactPanel';
import { Logger } from 'fsts';
import module_utils from '../module_utils';
import contactPanel, { Value, ContactPanel } from '@/shared/model/contactPanel';
import { AxiosResponse } from 'axios';
import i18n from '@/i18n';
import { CONST } from '@/shared/utils/Constants';

const logger = new Logger('actions.contactPanels');
export const actions: ActionTree<ContactPanelState, RootState> = {
  getContactPanels({ commit, dispatch, getters, rootGetters }, payload?: { searchParams?: any }) {
    commit('setContactPanelsIsLoading', true);
    let searchParams = payload?.searchParams ?? getters.getContactPanelsSearchParams;
    let organisationId = CONST.emptyGuid;
    return defaultBackendContactPanel
      .getContactPanels(searchParams, organisationId)
      .then((response: AxiosResponse<Value>) => {
        commit('setContactPanels', response.data);
        commit('setContactPanelsIsLoading', false);
        return response.data;
      })
      .catch((e: any) => {
        commit('setContactPanelsIsLoading', false);
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  getContactPanel({ commit, dispatch }, email: string) {
    return defaultBackendContactPanel
      .getContactPanel(email)
      .then((response: AxiosResponse<ContactPanel>) => {
        return response.data;
      })
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateContactPanel({ commit, dispatch }, file: ContactPanel) {
    return defaultBackendContactPanel
      .updateContactPanel(file)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: ContactPanel;
          }>
        ) => {
          module_utils.ok(i18n.tc(`success.contactPanel_update`), commit);
          return response.data;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  updateContactPanelKatalogwand({ commit, dispatch }, file: ContactPanel) {
    return defaultBackendContactPanel
      .updateContactPanelKatalogwand(file)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: ContactPanel;
          }>
        ) => {
          module_utils.ok(i18n.tc(`success.contactPanelKatalogwand_update`), commit);
          return response.data;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
  deleteContactPanel({ commit, dispatch }, id: string) {
    return defaultBackendContactPanel
      .deleteContactPanel(id)
      .then(
        (
          response: AxiosResponse<{
            errors: [];
            id: string;
            isValid: boolean;
            result: ContactPanel;
          }>
        ) => {
          return response;
        }
      )
      .catch((e: any) => {
        module_utils.error('error', commit, e, logger);
        throw e;
      });
  },
};
